import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Grid, Typography } from 'core/components/library';
import {
    Combo,
    DataGridPro as DataGrid,
    Literal,
    Switch,
    Tag,
    Text,
    ViewEntity
} from 'core/components';
import DetailMarca from '../../../../Marcas/Detalle';
import { ENTITY_MARCA } from '../../../../../../store/entities/constants';
import * as constants from 'core/constants';
import * as IconsSelector from 'core/icons';
import * as enums from 'core/enums';
import { statesEntity } from 'core/enums';
import * as icons from '../../../../../../core/icons';
import List from '../../../../../../store/List';

const ComboNCRs = List(Combo, 'options', 'lstNCRs');

const colsMarcas = (row, entity) => [
    {
        key: 'denominacion',
        title: 'Denominación',
        align: 'left',
        //width: '30%',
        component: row && (
            <Literal text={row.nombre}>
                <IconsSelector.BrandsIcon fontSize={'small'} />
            </Literal>
        )
    },
    {
        key: 'acronimo',
        title: 'Acronimo',
        align: 'left',
        //width: '55%',
        component: row && row.acronimo
    },
    {
        key: 'para',
        title: 'Elaborado para',
        align: 'left',
        //width: '55%',
        component: row && row.para
    }
];

const colsNCRs = (name, row, index, editing, handleChange, refresh) => [
    {
        key: 'descripcion',
        title: 'NCR (Nombre Comercial Registrado)',
        align: 'left',
        width: '100%',
        component: row && (
            <Text
                fullWidth
                variant='standard'
                name='descripcion'
                value={row.descripcion}
                onChange={
                    handleChange &&
                    (values => handleChange(values, name, index))
                }
                editing={editing}
            />
        )
    }
];

const Marcas = props => {
    const { values, editing, execAction, refresh, handleChange } = props;
    const entityData = useSelector(state => state.entities[ENTITY_MARCA]);

    return (
        <Grid container spacing={5}>
            <Grid item xs>
                <DataGrid
                    name='marcas'
                    editing={editing}
                    rows={values.marcas ? values.marcas : []}
                    cols={(name, row, index) => colsMarcas(row, entityData)}
                    onDelete={(name, index, row) => {
                        execAction(
                            {
                                api: entityData.api,
                                metodo: 'delete',
                                data: [row.id]
                            },
                            [() => refresh(false)]
                        );
                    }}
                    maxHeight={456}
                >
                    <ViewEntity
                        maxWidth={'lg'}
                        key={ENTITY_MARCA}
                        refresh={refresh}
                        entity={entityData}
                        initValue={{ bodega: { id: values.id } }}
                    >
                        {DetailMarca}
                    </ViewEntity>
                </DataGrid>
            </Grid>
            <Grid item xs={4}>
                <DataGrid
                    name='ncrs'
                    editing={editing}
                    rows={values.ncrs ? values.ncrs : []}
                    cols={(name, row, index) =>
                        colsNCRs(
                            name,
                            row,
                            index,
                            editing,
                            handleChange,
                            refresh
                        )
                    }
                    onAdd={name => {
                        handleChange({}, name);
                    }}
                    onDelete={(name, index) =>
                        handleChange(undefined, name, (index + 1) * -1)
                    }
                    minHeight={250}
                    maxHeight={250}
                />
            </Grid>
        </Grid>
    );
};

export default Marcas;
